import React from "react";

export default class SubNav extends React.PureComponent {
  constructor(props) {
    super(props);
    this.searchSubmit = this.searchSubmit.bind(this);
  }

  searchSubmit(e) {
    e.preventDefault();
    window.location = "https://www.watchandwager.com/search/" + this.refs.search_input.value;
  }

  render() {
    return (
      <nav className="nav nav--sub">
        <ul className="nav_table">
          <li className="nav_item">
            <a className="nav_link" href="https://www.watchandwager.com/results">
              <span className="nav_link--triangle">
                Wager
              </span>

              {" "}
              Now
            </a>
          </li>

          <li className="nav_item">
            <a className="nav_link" href="https://www.watchandwager.com/results">
              Results
            </a>
          </li>

          <li className="nav_item nav_item--secondary">
            <a className="nav_link" href="https://www.watchandwager.com/tracks">
              Tracks
            </a>
          </li>

          <li className="nav_item">
            <a className="nav_link" href="https://www.watchandwager.com/news">
              News
            </a>
          </li>

          <li className="nav_item nav_item--secondary">
            <a className="nav_link" href="https://www.watchandwager.com/faqs">
              FAQs
            </a>
          </li>

          <li className="nav_item nav_item--secondary">
            <a className="nav_link" href="https://www.watchandwager.com/help">
              Help
            </a>
          </li>

          <li className="nav_item nav_item--secondary">
            <a className="nav_link" href="https://www.watchandwager.com/rewards">
              Rewards
            </a>
          </li>

          <li className="nav_item nav_item--secondary">
            <a className="nav_link" href="http://blog.watchandwager.com/">
              Blog
            </a>
          </li>
        </ul>

        <ul className="nav_table nav_table--social-media">
          <li className="nav_item">
            <a className="nav_link nav_link--facebook" href="https://www.facebook.com/watchandwager">
              <i className="dw-facebook" />
            </a>
          </li>

          <li className="nav_item">
            <a className="nav_link nav_link--twitter" href="https://twitter.com/watchandwager">
              <i className="dw-twitter" />
            </a>
          </li>

          <li className="nav_item">
            <a className="nav_link nav_link--instagram" href="https://www.instagram.com/watchandwager/">
              <svg className="instagram_icon" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>
          </li>

          <li className="nav_item nav_item--search">
            <form className="search_form" onSubmit={this.searchSubmit}>
              <input className="form_input" id="search_input" name="search_input" placeholder="Search..." ref="search_input" type="text" />

              <button className="search_submit" type="submit">
                <svg className="search_icon" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.809 21.646l-6.205-6.205c1.167-1.605 1.857-3.579 1.857-5.711 0-5.365-4.365-9.73-9.731-9.73-5.365 0-9.73 4.365-9.73 9.73 0 5.366 4.365 9.73 9.73 9.73 2.034 0 3.923-.627 5.487-1.698l6.238 6.238 2.354-2.354zm-20.955-11.916c0-3.792 3.085-6.877 6.877-6.877s6.877 3.085 6.877 6.877-3.085 6.877-6.877 6.877c-3.793 0-6.877-3.085-6.877-6.877z" />
                </svg>
              </button>
            </form>
          </li>
        </ul>
      </nav>
    );
  }
}
